import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import Config from "../Config";
import { useNavigate } from "react-router-dom";
import { useAuthHandling } from "../useAuthhandling";
import Cookies from "js-cookie";
function Projectgraph() {

  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }


  const [project, setProject] = useState([]);


  const [options, setOptions] = useState({
    colors: ["#a299ff", "#9C27B0"],
    labels: [], // Initialize labels as empty, will be populated later

    fill: {
      colors: ["#a299ff", "#9C27B0"],
    },
    stroke: {
      colors: ["#a299ff", "#9C27B0"],
      curve: "smooth",
    },
    markers: {
      colors: ["#a299ff", "#9C27B0"],
    },

    title: {
      text: "No of Completed project vs ongoing project",
      align: "left",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,

      style: {
        fontSize: "14px",
        fontWeight: "400",
        fontFamily: undefined,
        color: "#fff",
        marginTop: "12px",
      },
    },
  });

  const [series, setSeries] = useState([
    { name: "Completed Project", data: [] },
    { name: "Ongoing Project", data: [] },
  ]);


  const getDashboard = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/dashboard/get-projects-month-wise`, {
      method: "GET",
      headers: { "Content-Type": "application/json" ,
      Authorization: `Bearer ${Cookies.get("a_token")}`,

    },
    });
    if (res.status === 200) {
      const data = await res.json();
      setProject(data.data);
      const dataFromDB = data.data;
      const months = Array.from({ length: 12 }, (_, index) => index + 1);
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    // Extract counts for each month
    const monthlyCounts = months.map((month) => {
      const monthData = dataFromDB.find((item) => item.month === month);
      if (monthData) {
        const completedCount = monthData.counts.find(
          (count) => count.status === "Completed"
        );
        const ongoingCount = monthData.counts.find(
          (count) => count.status === "Ongoing"
        );
        return {
          completed: completedCount ? completedCount.count : 0,
          ongoing: ongoingCount ? ongoingCount.count : 0,
        };
      } else {
        return { completed: 0, ongoing: 0 };
      }
    });

    // Set labels and series
    // setOptions((prevOptions) => ({
    //   ...prevOptions,
    //   labels: months.map((month) => month.toString()),
    // }));

    setOptions((prevOptions) => ({
      ...prevOptions,
      labels: months.map((month) => monthNames[month - 1]), // Adjust month names
    }));

    setSeries([
      {
        name: "Completed Project",
        data: monthlyCounts.map((count) => count.completed),
      },
      {
        name: "Ongoing Project",
        data: monthlyCounts.map((count) => count.ongoing),
      },
    ]);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getDashboard();
    }
    else {
      alert("error");

    }
  };

  useEffect(() => {
   
    getDashboard();
  }, []);

  // const [options, setOptions] = useState({
  //   colors: ["#a299ff", "#9C27B0"],
  //   labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July"],

  //   fill: {
  //     colors: ["#a299ff", "#9C27B0"],
  //   },
  //   stroke: {
  //     colors: ["#a299ff", "#9C27B0"],

  //     curve: "smooth",
  //   },
  //   markers: {
  //     colors: ["#a299ff", "#9C27B0"],
  //   },

  //   title: {
  //     text: "No of Completed project vs ongoing project",
  //     align: "left",
  //     margin: 10,
  //     offsetX: 0,
  //     offsetY: 0,
  //     floating: false,

  //     style: {
  //       fontSize: "14px",
  //       fontWeight: "400",
  //       fontFamily: undefined,
  //       color: "#fff",
  //       marginTop: "12px",
  //     },
  //   },
  // });

  // const series = [
  //   {
  //     type: "line",
  //     name: "Completed Project",
  //     data: [19, 22, 20, 26, 30, 23, 31],
  //   },
  //   {
  //     type: "line",
  //     name: "Ongoing Project",
  //     data: [13, 15, 19, 30, 25, 35, 18],
  //     // strokeDashArray: 3,
  //   },
  // ];

  
  return (
    <div className="projectgraph">
      <Chart
        options={options}
        type="line"
        series={series}
        width="100%"
        height="300px"
      />
    </div>
  );
}

export default Projectgraph;
